__webpack_require__.p = "https://fr-investment-fe.dev.securitize.io/";